import { useRef } from 'react';
import { createWorkletProcessorCode } from '../utils/createWorkletProcessor';

// eslint-disable-next-line import/prefer-default-export
export function useAudioPipeline() {
  const audioContextRef = useRef(null);

  async function init(track, onData) {
    const audioContext = new AudioContext({ sampleRate: 16000 });
    audioContextRef.current = audioContext;

    const source = audioContext.createMediaStreamSource(new MediaStream([track]));

    const workletURL = URL.createObjectURL(
      new Blob([createWorkletProcessorCode()], { type: 'application/javascript' })
    );
    await audioContext.audioWorklet.addModule(workletURL);

    const processor = new AudioWorkletNode(audioContext, 'audio-processor');
    processor.port.onmessage = (event) => onData(event.data.buffer);

    source.connect(processor).connect(audioContext.destination);
  }

  function cleanup() {
    audioContextRef.current?.close();
    audioContextRef.current = null;
  }

  return { init, cleanup };
}
